import React from 'react';
import ReactMarkdown from 'react-markdown';

import './blindvei.scss';

interface BlindveiProps {
    tittel: string;
    ingress: string;
}

export const Blindvei = ({ tittel, ingress }: BlindveiProps) => (
    <div className="blindvei-sporsmal-wrapper">
        <div className="blindvei-sporsmal-container">
            <h2>{tittel}</h2>
            <ReactMarkdown>{ingress}</ReactMarkdown>
        </div>
    </div>
);
